import { render, staticRenderFns } from "./supplier-picker.vue?vue&type=template&id=6b28f087&"
import script from "./supplier-picker.vue?vue&type=script&lang=js&"
export * from "./supplier-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports